import React from 'react';
import MuiAlert from '@mui/lab/Alert';


export default function MUIToast({ children, appearance }) {

    return <MuiAlert sx={{mb: 1}} elevation={3} variant="filled" severity={appearance} children={children} />;
}

MUIToast.defaultProps = {
    appearance: 'success',
};
